module.exports = __webpack_public_path__ + "img/group_avatar_guarantee_5.be94ce6b.png";